import React from "react";
import "./LoadingIndicator.css";

type props = {
  loading: boolean;
  className?: string;
};

const LoadingIndicator: React.FC<props> = ({ loading, className }) => {
  return loading ? (
    <div className={`loading-overlay ${className ?? ""}`}>
      <img
        src="https://ultracdn.blob.core.windows.net/public/ultra-chat-loading.gif"
        alt=""
      />
    </div>
  ) : null;
};

export default LoadingIndicator;
